import React, {useEffect, useState} from "react";
import {Form, Modal} from "react-bootstrap";
import {useFormik} from "formik";
import {apiGenericCreate, apiGenericUpdate, genericGetOne} from "../generic/crud";
import {ENTITY_ID_DEALER} from "../generic/Constants";
import {defaultDealer} from "../generic/InitialStates";
import {showToast, TOAST_SUCCESS} from "../../utils/toast/Toast";
import {AGCText} from "../../generic-components/AGCText";
import {AGCTextArea} from "../../generic-components/AGCTextArea";
import {AGCStaticSelect} from "../../generic-components/AGCStaticSelect";
import {OEM_LIST} from "../generic/OEMList";


export function DealerAddEditDialog(props) {
    const {show, handleClose, id, onSave} = props;
    const [forUpdate, setForUpdate] = useState(false);
    const [objectForSubmit, setObjectForSubmit] = useState(defaultDealer);
    const [isLoading, setIsLoading] = useState(false);
    const [title, setTitle] = useState("Dealer");
    const entityName = "Dealer";

    const formik = useFormik({
        initialValues: objectForSubmit,
        enableReinitialize: true,
        onSubmit(dealer, {resetForm}) {
            setIsLoading(true);

            // Convert brand object to just the ID string
            if (dealer.brand && dealer.brand.id) {
                dealer.brand = dealer.brand.id;
            }

            if (!id) {
                apiGenericCreate(ENTITY_ID_DEALER, dealer).then(() => {
                    setIsLoading(false);
                    handleClose();
                    showToast(entityName + " is Created!", TOAST_SUCCESS);
                    resetForm();
                    if (onSave) onSave();
                }).catch(() => {
                    setIsLoading(false);
                });
            } else {
                apiGenericUpdate(ENTITY_ID_DEALER, dealer, id).then(() => {
                    setIsLoading(false);
                    handleClose();
                    showToast(entityName + " is Updated!", TOAST_SUCCESS);
                    resetForm();
                    if (onSave) onSave();
                }).catch(() => {
                    setIsLoading(false);
                });
            }
        }
    });

    useEffect(() => {
        if (id != null) {
            setForUpdate(true);
            setTitle("Edit " + entityName);
            setIsLoading(true);

            genericGetOne(ENTITY_ID_DEALER, id).then(
                ({data}) => {
                    // Convert brand string to object for AGCStaticSelect
                    if (data.brand) {
                        const brandObj = OEM_LIST.find(oem => oem.id === data.brand);
                        data.brand = brandObj || {id: data.brand, name: data.brand};
                    }

                    setObjectForSubmit(data);
                    setTitle("Update " + entityName);
                    setIsLoading(false);
                })
                .catch(() => {
                    setIsLoading(false);
                });
        } else {
            setForUpdate(false);
            setObjectForSubmit(defaultDealer);
            setTitle("New " + entityName);
        }
    }, [show]);


    return (
        <Modal
            size="lg"
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            aria-labelledby="example-modal-sizes-title-lg">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="overlay">
                {!isLoading && (
                    <Form className="form form-label-right">
                        <div className="form-group row">

                            <Form.Group className="col-lg-6">
                                <AGCText formik={formik}
                                         name={"Dealer Name"}
                                         placeHolder={'Enter Dealer Name'}
                                         id={"name"}
                                         toolTip={"Please enter the Dealer Name"}
                                         value={formik.values.name}/>
                            </Form.Group>

                            <Form.Group className="col-lg-6">
                                <AGCStaticSelect
                                    formik={formik}
                                    isMulti={false}
                                    id={'brand'}
                                    name={"Select Brand"}
                                    data={OEM_LIST}
                                    value={formik.values.brand}
                                    toolTip={"Please select the Brand (OEM)"}
                                    forUpdate={forUpdate}/>
                            </Form.Group>
                        </div>

                        <div className="form-group row">
                            <Form.Group className="col-lg-12">
                                <AGCTextArea formik={formik}
                                         name={"Address"}
                                         placeHolder={'Enter Address'}
                                         id={"address"}
                                         toolTip={"Please enter the Address"}
                                         value={formik.values.address}
                                         rows={3}/>
                            </Form.Group>
                        </div>

                        <div className="form-group row">
                            <Form.Group className="col-lg-6">
                                <AGCText formik={formik}
                                         name={"Operating City"}
                                         placeHolder={'Enter Operating City'}
                                         id={"operatingCity"}
                                         toolTip={"Please enter the Operating City"}
                                         value={formik.values.operatingCity}/>
                            </Form.Group>

                            <Form.Group className="col-lg-6">
                                <AGCText formik={formik}
                                         name={"GST Number"}
                                         placeHolder={'Enter GST Number'}
                                         id={"gstNumber"}
                                         toolTip={"Please enter the GST Number"}
                                         value={formik.values.gstNumber}/>
                            </Form.Group>
                        </div>

                        <br/>
                        <Modal.Footer>
                            <div>
                                <button
                                    type="button"
                                    className="btn btn-light btn-elevate"
                                    onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    onClick={formik.handleSubmit}
                                    className="btn btn-primary btn-elevate">
                                    Save
                                </button>
                            </div>
                        </Modal.Footer>
                    </Form>
                )}
                {isLoading && <span>Please Wait, Fetching Information from Server</span>}
            </Modal.Body>
        </Modal>
    );
}
